import { format } from 'date-fns'
import { enUS } from 'date-fns/locale'
import { i18nextContainer } from 'shared/configs/i18n/config'

import { dateFnsLocaleMap } from './dateFns'

/**
 * Formats a given date into a localized date-time string.
 *
 * - Uses `date-fns` for formatting.
 * - Applies the correct locale based on the current i18n language.
 * - Falls back to `enUS` if the language is not supported in `dateFnsLocaleMap`.
 * - The format is `P 'at' p` where:
 *    - `P` is the localized date format
 *    - `'at'` is translated using i18n
 *    - `p` is the localized time format
 *
 * Example output (en): `12/08/2025 at 2:45 PM`
 * Example output (de): `12.08.2025 um 14:45`
 *
 * @param {Date} date - The date to format.
 * @returns {string} The localized formatted date-time string.
 */
export const formatDateTimeWithLocale = (date: Date): string => {
  const locale = dateFnsLocaleMap[i18nextContainer.language] || enUS

  return format(date, `P '${i18nextContainer.t('common.at')}' p`, { locale })
}
